module.exports = __webpack_public_path__ + "static/media/promo-banner-mobile.4430d196.jpg";